"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=IEvent.js.map